window._ = require('lodash');
window.Popper = require('popper.js').default;
window.moment = require('moment');

/**
 * We'll load jQuery and the Bootstrap jQuery plugin which provides support
 * for JavaScript based Bootstrap features such as modals and tabs. This
 * code may be modified to fit the specific needs of your application.
 */

try {
  window.$ = window.jQuery = require('jquery');

  require('bootstrap');
  require('bootstrap-datepicker');
  require('select2');

  window.bsCustomFileInput = require('bs-custom-file-input');

  window.intlTelInput = require('intl-tel-input');

  require('pc-bootstrap4-datetimepicker');
  $.extend(true, $.fn.datetimepicker.defaults, {
    icons: {
      time: 'far fa-clock',
      date: 'far fa-calendar',
      up: 'fas fa-arrow-up',
      down: 'fas fa-arrow-down',
      previous: 'fas fa-chevron-left',
      next: 'fas fa-chevron-right',
      today: 'fas fa-calendar-check',
      clear: 'far fa-trash-alt',
      close: 'far fa-times-circle'
    }
  });
} catch (e) {}

window.modifyQueryParams = require('./lib/url').modifyQueryParams;
window.JSONFormatter = require('json-formatter-js');

$(document).ready( function() {
    bsCustomFileInput.init();

    $('.js-btnMenu').on('click', function () {
        $(this).find('i').toggleClass('fa-arrow-left').toggleClass('fa-arrow-right');
        let body = $('body');
        body.toggleClass('hide-menu');
        window.localStorage.setItem('hide-menu', body.hasClass('hide-menu') ? '1' : '0');
    });

    $("#from_date, #to_date, #start_date, #end_date").datepicker({
        autoclose: true,
        format: "mm/dd/yyyy"
    });

    $('.datepicker-group i, .datepicker-input i').on('click', function(){
        $(this).closest('div').find('.form-control').select();
    });

});

if (window.localStorage.getItem('hide-menu') === '1') {
    $('.js-btnMenu').find('i').removeClass('fa-arrow-left').addClass('fa-arrow-right');
    $('body').addClass('hide-menu');
}
